import React, { ReactNode, useEffect, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';
import { useHistory, useParams } from 'react-router-dom';
import { DCR_API_BASE_SERVER_URL } from 'config';
import MessageModal from 'components/MessageModal';
import Tile from 'components/Tile/Tile';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import {
  GET_CREDIT_SUBMISSION,
  M_BOOK_DEAL_LMS,
  Q_CREDIT_APP,
  Q_EQUIPMENT,
  QUERY_PORTAL_CONFIGURATION,
} from '../../components/SubmissionDetailsTabs_V2/queries/queries';
import { SET_CHAT_TARGET_RECIPIENT, SET_VO } from '../../redux/types';
import { CHAT_V2_SET_TARGET_CREDIT_SUBMISSION_ID } from 'redux/types';
import { Q_VO, QUERY_ACTIVE_OCA_TEMPLATE } from '../../queries/common';
import { portalConfigurationTypes } from '../Prequal/constants';
import { checkIfIndividualCreditApp } from '../../utils';
import {
  assignFieldsOCAConfigFromActiveTemplate,
  isItemHasRestrictionForRole,
} from '../../services/creditAppModalService';
import { getDefaultPortalConfigurationByType, rolesSettingsKeys } from '../../services/pcwService';
import {
  Box,
  Button,
  CircularProgress,
  Container,
  FormControl,
  FormControlLabel,
  FormLabel,
  Modal,
  Radio,
  RadioGroup,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material';
import { Breadcrumbs } from '../../components/Breadcrumbs/Breadcrumbs';
import TransactionSummary from '../LenderPortal/CreditSubmissionDetails/TransactionSummaryCard';
import ApplicationSummary_V2 from '../LenderPortal/CreditSubmissionDetails/ApplicationSummary__V2';
import { SpecificTasks_V2 } from '../../components/SpecificTasks_V2';
import { LenderWaterfallResults } from '../VendorOpportunity/LenderWaterfallResults';
import { invoiceDetailAPIKey } from '../../components/SubmissionDetailsTabs_V2/configuration';
import { parseTableData } from '../../components/SubmissionDetailsTabs_V2/helpers';
import Paper from '@mui/material/Paper';
import { CardBackground } from '../../components/CardBackground/CardBackground';
import HealthCheckCard from '../VendorOpportunity/HealthCheckCard';
import FDRList from '../LenderPortal/CreditSubmissionDetails/FDRCard';
import ActivityList from '../LenderPortal/CreditSubmissionDetails/ActivityCard';

import { InvoiceEquipmentDetailsCard_V2 } from '../../components/InvoiceEquipmentDetailCard_V2/ui';
import { BpfLinkType, DealActivityLinkType, PortalConfigurationType } from '@trnsact/trnsact-shared-types';
import { CreditSubmissionTabs } from './types';
import { CreditSubmissionResponse, CreditSubmissionVariables } from '../../components/SubmissionDetailsTabs_V2/types';
import { Documents_V2 } from '../../components/Documents_V2';
import { SyndicationsList_V2 } from '../../components/SyndicationsList_V2/ui';
import { ProposalList_V2 } from '../../components/ProposalList_V2/ui';
import { DocumentContext } from 'contexts/DocumentContext';
import { ModalsKeys, PageTypes, TabsOption } from '../../global';
import { CreditApplicationDetailsFullView } from '../../modules/creditApplicationDetails';
import ApplicationSummaryModal from 'pages/LenderPortal/CreditSubmissionDetails/ApplicationSummaryModal';
import axios from 'axios';
import { TabsContainer } from 'components/shared/TabsContainer/TabsContainer';
import { portalConfigurationsSelectors } from '../../redux/portalConfigurationReducer';
import { PageContainer } from 'components/shared/Page/PageContainer';
import LMSResults from 'components/LMS';
import SendIcon from '@mui/icons-material/Send';
import { ScoreCardV2 } from 'pages/VendorOpportunity/ScoreCardV2';
import { DocuSignDialog } from 'modules/integrations/docuSign';
import LMSMappingModal, {
  DynamicLenderMappingField,
} from 'pages/VendorOpportunity/LenderSubmissionMappingModals/LMSMappingModal';
import { DecisionCard, DetailsCard, LenderDeskingPanel } from 'modules/creditSubmission';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { collectInvoiceFromVO } from 'modules/invoice';
import { SubsidyCalculatorPanel } from 'modules/subsidyCalculator';
import { RenderWithFallback } from '../../components/shared/Conditional/RenderWithFallback';
import { voSelectors } from '../../redux/voReducer';
import gql from 'graphql-tag';
import { ClosedDealInfo, StagesWidget } from 'modules/stages';
import { PortalConfiguration } from '../../modules/portalConfigurations/types';
import { LenderFeatureFlagsPortalConfiguration } from 'modules/portalConfigurations';
import { ActivityDialog, CallActivityDialog, DealActivityCard, NoteActivityDialog } from 'modules/dealActivity';
import ScoreCard from 'pages/LenderPortal/CreditSubmissionDetails/ScoreCard';
import { getCcEmailOptions } from '../VendorOpportunity/DetailPages/lib';
import { getCcEmailPreSelectedValue } from '../../modules/desking/lib/convertVOToInitialFormValue';
import { VendorOpportunityTabs } from '../VendorOpportunity/DetailPages/types';

const QUERY_DEALER_VENDOR_PROFILE = gql`
  query GetDealerVendorProfile($id: ID, $dynamicsId: ID, $userProfileId: ID, $VOId: ID) {
    vendorProfile(id: $id, dynamicsId: $dynamicsId, userProfileId: $userProfileId, VOId: $VOId) {
      id
      name
      dynamicsId
      showDocMgt
      showLenderDocsAccessMgmt
      softPullInDealerPortal
      ofacRedFlagComplianceAccess
      showCreditApp
      showPsOptions
      showMarginTool
      showLenderSubmission
      industryGroupType
      role
      logo
      settingBusinessCreditReportPullInDealerPortal
      dcrDisclosureLanguage
      dcrDisclosureTerms
    }
  }
`;

const modalsWithKeys: Partial<Record<ModalsKeys, ReactNode>> = {
  [ModalsKeys.DocuSignDialog]: <DocuSignDialog />,
  [ModalsKeys.ActivityDialog]: <ActivityDialog />,
  [ModalsKeys.CallActivityDialog]: <CallActivityDialog />,
  [ModalsKeys.NoteActivityDialog]: <NoteActivityDialog />,
};

export const CreditSubmissionDetailsPageV2 = () => {
  const { push } = useHistory();
  const { id } = useParams<{ id: string }>();

  const [lastDocument, setLastDocument] = useState<any>();
  const dispatch = useDispatch();

  const relatedUsers = useSelector((state: any) => state.relatedUsers);
  const lenderProfile = useSelector((state: any) => state.lenderProfile);
  const userProfile = useSelector((state: any) => state.userProfile);
  const account = useSelector((state: any) => state.account);

  const refetchCS = useSelector((state: any) => state.cs.refetch);
  const vp = useSelector((state: any) => state.vp);
  const hideScoreCard = useSelector(portalConfigurationsSelectors.isPrescreenScorecardBuilderHidden);

  const allowSyndication = !!useSelector(state => portalConfigurationsSelectors.configData(state))?.[
    PortalConfigurationType.Portal
  ]?.jsonDefinition?.config?.allowSyndication;

  const allowLMS = useSelector(state => portalConfigurationsSelectors.configData(state))?.[
    PortalConfigurationType.Portal
  ]?.jsonDefinition?.config?.allowLMS;

  const isSubsidyCalculatorEnabled = !!useSelector(state => portalConfigurationsSelectors.configData(state))?.[
    PortalConfigurationType.Portal
  ]?.jsonDefinition?.config?.subsidyCalculator;

  const enableEnhancedBusinessProcessFlows =
    useSelector<any, PortalConfiguration<LenderFeatureFlagsPortalConfiguration>>(state =>
      portalConfigurationsSelectors.configDataByType(state, PortalConfigurationType.LenderFeatureFlags)
    )?.jsonDefinition?.config?.enableEnhancedBusinessProcessFlows ?? false;

  const classes = useStyles();
  const [openMessageModal, setOpenMessageModal] = useState<boolean>(false);
  const [submissionMessage] = useState<any>({});
  const [openLegacyDetailsModal, setOpenLegacyDetailsModal] = useState<boolean>(false);
  const [openLMSMappingModal, setOpenLMSMappingModal] = useState<boolean>(false);
  const [handleSubmitToLenderByProfileId, setHandleSubmitToLenderByProfileId] = useState<boolean>(false);

  const [appSummary, setAppSummary] = useState<any>();

  const [dealerVendorProfile, setDealerVendorProfile] = useState<any>(null);
  const [lmsCodeName, setLmsCodeName] = useState<string>('');

  const [lastSubmissionDate, setLastSubmissionDate] = useState<Date | null>(null);
  const [initialLmsSubmissionDate, setInitialLmsSubmissionDate] = useState<Date | null>(null);
  const [location, setLocation] = useState<any>(null);
  const [CADMData, setCADMData] = useState<any>(null);
  const [ocaTemplateToUse, setOcaTemplateToUse] = useState<any>(null);
  const [isLegacyOCA, setIsLegacyOCA] = useState<boolean>(false);
  const [portalConfigurations, setPortalConfigurations] = useState<any>(null);
  const [CADMPortalConfiguration, setCADMPortalConfiguration] = useState<any>(null);
  const [isCreditReportsHiddenForUserRole, setIsCreditReportsHiddenForUserRole] = useState<boolean>(true);
  const [isIndividualCreditApp, setIsIndividualCreditApp] = useState<boolean>(false);

  // This docs use only for 'handleOpenCreditReportDocument' handler
  const [documents, setDocuments] = useState<any>([]);

  const [showHealthCheck, setShowHealthCheck] = useState<boolean>(false);
  const [isHealthCheckHiddenForUserRole, setIsHealthCheckHiddenForUserRole] = useState<boolean>(true);

  const [triggerRefetchDocs, setTriggerRefetchDocs] = useState<any>('');

  const [allConfigurationsLoaded, setAllConfigurationsLoaded] = useState(false);
  const vo = useSelector(voSelectors.selectVOEntity);
  const voPrioritizedDealerEmail = useSelector(voSelectors.selectVODealerEmail);

  const handleCloseModal = () => {
    setOpenMessageModal(false);
  };
  const handleClose = () => {
    setOpenLegacyDetailsModal(false);
  };
  const displayLMSModal = (creditSubmissionId: string | undefined | null) => {
    if (creditSubmissionId) {
      //display LMS Mapping Modal
      setOpenLMSMappingModal(true);
    }
  };

  const handleCloseLMSMappingModal = () => {
    setOpenLMSMappingModal(false);
  };

  const {
    refetch,
    data: creditSubmissionData,
    error: creditSubmissionError,
    loading: isLoadingCreditSubmissionData,
  } = useQuery<CreditSubmissionResponse, CreditSubmissionVariables>(GET_CREDIT_SUBMISSION, {
    fetchPolicy: 'network-only',
    variables: { csId: id },
    context: { authRequired: true },
  });

  const dynamicsLenderProfileId = (creditSubmissionData?.creditSubmission as any)?.dynamicsLenderProfileId ?? '';
  const isLenderDeskingEnabled =
    !!vp &&
    (
      creditSubmissionData?.creditSubmission?.lenderProfiles?.find(
        lenderProfile => lenderProfile?.lenderProfileId === dynamicsLenderProfileId
      ) as any
    )?.isEnhancedSubmissionsFlowEnabled;

  const [bookDealLMS] = useMutation(M_BOOK_DEAL_LMS, {
    context: { authRequired: true },
    onCompleted(data) {
      console.log(data);
      setLastSubmissionDate(new Date());
    },
  });
  useEffect(() => {
    if (lastSubmissionDate) {
      setTimeout(() => {
        refetch();
      }, 5000);
    }
  }, [lastSubmissionDate]);

  const { data: dataVendorProfile } = useQuery(QUERY_DEALER_VENDOR_PROFILE, {
    notifyOnNetworkStatusChange: true,
    skip: !creditSubmissionData?.creditSubmission?.voId,
    context: { authRequired: true },
    variables: {
      VOId: creditSubmissionData?.creditSubmission?.voId,
    },
  });

  useEffect(() => {
    if (dataVendorProfile !== null && dataVendorProfile !== undefined) {
      setDealerVendorProfile(dataVendorProfile);
    }
  }, [dataVendorProfile]);

  const [
    getPortalConfigurations,
    { data: portalConfigurationData, loading: portalConfigurationDataLoading, called: portalConfigurationDataCalled },
  ] = useLazyQuery(QUERY_PORTAL_CONFIGURATION, {
    context: { authRequired: true },
    fetchPolicy: 'no-cache',
  });

  const [
    getCADMPortalConfigurations,
    {
      data: CADMPortalConfigurationData,
      loading: CADMPortalConfigurationDataLoading,
      called: CADMPortalConfigurationDataCalled,
    },
  ] = useLazyQuery(QUERY_PORTAL_CONFIGURATION, {
    context: { authRequired: true },
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (
      portalConfigurationDataCalled &&
      CADMPortalConfigurationDataCalled &&
      !(portalConfigurationDataLoading || CADMPortalConfigurationDataLoading)
    ) {
      setAllConfigurationsLoaded(true);
    }
  }, [
    portalConfigurationDataCalled,
    CADMPortalConfigurationDataCalled,
    portalConfigurationDataLoading,
    CADMPortalConfigurationDataLoading,
  ]);

  const [getActiveOcaTemplate] = useLazyQuery(QUERY_ACTIVE_OCA_TEMPLATE, {
    fetchPolicy: 'no-cache',
    onCompleted(data) {
      setOcaTemplateToUse(_.first(data.getOcaTemplatesByVendorProfile));
    },
  });

  const [getCreditAppData, { data: creditAppData, loading: isCreditAppLoading }] = useLazyQuery(Q_CREDIT_APP, {
    fetchPolicy: 'no-cache',
  });

  const [getEquipmentData, { data: equipmentData, loading: isLoadingEquipmentData }] = useLazyQuery(Q_EQUIPMENT);

  const [getVoData, { data: voData }] = useLazyQuery(Q_VO, { fetchPolicy: 'no-cache' });

  const handleOpenCreditReportDocument = (_: any, cbr: any) => {
    const reportDoc = documents.find((d: any) => d.key === cbr.humanReadableReportDocumentId);
    if (reportDoc) {
      window.open(reportDoc.link, '_newtab');
    }
  };

  useEffect(() => {
    if (creditSubmissionData) refetch();
  }, [refetchCS]);

  useEffect(() => {
    if (creditSubmissionData) {
      const lastLmsSubmission = _.get(creditSubmissionData, 'creditSubmission.lmsBookedData.submissionDate');
      if (!initialLmsSubmissionDate && lastLmsSubmission) {
        setInitialLmsSubmissionDate(lastLmsSubmission);
      }

      const cs = creditSubmissionData.creditSubmission;

      const voId = _.get(cs, 'voId', '');
      const creditSubId = _.get(cs, 'creditSubId', '');
      const contactUserProfileId = _.get(cs, 'contactUserProfileId', null);

      const targetRecipient = _.find(relatedUsers, {
        id: contactUserProfileId,
      });

      if (targetRecipient) {
        dispatch({
          type: SET_CHAT_TARGET_RECIPIENT,
          payload: {
            targetRecipient: [
              {
                id: targetRecipient.id,
                accountId: targetRecipient.account.id,
                mughshot: targetRecipient.mugshot,
                vendorContactRole: targetRecipient.vendorContactRole,
                email: targetRecipient.email,
                firstName: targetRecipient.firstName,
                lastName: targetRecipient.lastName,
                fullName: targetRecipient.fullName,
                mobilePhoneNumber: targetRecipient.mobilePhoneNumber,
                company: targetRecipient.account.name,
              },
            ],
          },
        });
      }

      dispatch({
        type: CHAT_V2_SET_TARGET_CREDIT_SUBMISSION_ID,
        payload: creditSubId,
      });

      getVoData({ variables: { voId } });
      getCreditAppData({ variables: { VOId: voId } });
      getEquipmentData({ variables: { VOId: voId } });
    }
  }, [creditSubmissionData, relatedUsers, dispatch]);

  const refetchDocs = () => {
    setTriggerRefetchDocs(new Date().getTime());
  };

  useEffect(() => {
    setLmsCodeName(_.get(account, 'lms[0]', ''));
  }, [account]);

  useEffect(() => {
    if (_.every([equipmentData, vo?.vendorOpportunityId, CADMPortalConfiguration, dealerVendorProfile])) {
      setCADMData({
        equipmentData,
        vo,
        CADMPortalConfiguration,
        vendorProfile: _.get(dealerVendorProfile, 'vendorProfile'),
      });
    }
  }, [equipmentData, vo, CADMPortalConfiguration, dealerVendorProfile, CADMPortalConfiguration]);

  useEffect(() => {
    if (_.get(dealerVendorProfile, 'vendorProfile.id')) {
      getPortalConfigurations({
        variables: {
          vendorProfileId: _.get(dealerVendorProfile, 'vendorProfile.id'),
          types: [portalConfigurationTypes.documents],
        },
      });
    }

    if (_.get(dealerVendorProfile, 'vendorProfile.ofacRedFlagComplianceAccess', false)) {
      setShowHealthCheck(true);
    }
  }, [dealerVendorProfile]);

  useEffect(() => {
    if (_.isEmpty(creditAppData?.creditApplication)) {
      return;
    }

    const { creditApplication } = creditAppData;

    const currentCreditAppOcaTemplate = creditApplication.ocaTemplate;
    let vpIdToGetCADMPortalConfigurations;
    if (currentCreditAppOcaTemplate) {
      // Credit app could be submitted from both the customer's and dealer's templates
      vpIdToGetCADMPortalConfigurations = currentCreditAppOcaTemplate.vendorProfileId;
      setOcaTemplateToUse(currentCreditAppOcaTemplate);
      setIsLegacyOCA(false);
    } else {
      // For OCAv3, currentCreditAppOcaTemplate will be empty, so we want to use Dealer's current active OCA template
      vpIdToGetCADMPortalConfigurations = vo.vendorProfileId;
      getActiveOcaTemplate({
        variables: {
          vendorProfileId: vo.vendorProfileId,
          isActive: true,
        },
      });
      setIsLegacyOCA(true);
    }

    getCADMPortalConfigurations({
      variables: {
        vendorProfileId: vpIdToGetCADMPortalConfigurations,
        types: [portalConfigurationTypes.CADMIndividual, portalConfigurationTypes.CADMCommercial],
      },
    });

    setLocation(_.get(creditAppData, 'creditApplication.location'));
  }, [creditAppData]);

  useEffect(() => {
    if (!CADMPortalConfigurationData || !creditAppData || !ocaTemplateToUse) return;

    const applicationType = _.get(creditAppData, 'creditApplication.applicationType');
    const portalConfigurations = _.get(CADMPortalConfigurationData, 'portalConfigurations') || [];
    const isIndividualCreditApp = checkIfIndividualCreditApp(applicationType);
    const CADMConfigurationTypeToUse = isIndividualCreditApp
      ? portalConfigurationTypes.CADMIndividual
      : portalConfigurationTypes.CADMCommercial;
    const CADMConfigurationToUse = _.find(portalConfigurations, { type: CADMConfigurationTypeToUse });
    if (_.some(CADMConfigurationToUse)) {
      assignFieldsOCAConfigFromActiveTemplate(CADMConfigurationToUse.jsonDefinition, ocaTemplateToUse.jsonDefinition);
    }
    setCADMPortalConfiguration(CADMConfigurationToUse);
    setIsIndividualCreditApp(isIndividualCreditApp);
  }, [CADMPortalConfigurationData, creditAppData, ocaTemplateToUse]);

  useEffect(() => {
    if (!portalConfigurationData) return;

    const portalConfigurations = _.get(portalConfigurationData, 'portalConfigurations') || [];

    const portalConfigurationsToSetByDefault = [portalConfigurationTypes.documents];
    _.forEach(portalConfigurationsToSetByDefault, portalConfigurationType => {
      if (!_.find(portalConfigurations, { type: portalConfigurationType })) {
        portalConfigurations.push(
          getDefaultPortalConfigurationByType(portalConfigurationType, account.vendorProfileId)
        );
      }
    });

    setPortalConfigurations(portalConfigurations);

    const isCreditReportsHiddenForUserRole = isItemHasRestrictionForRole(
      _.get(portalConfigurations, `${portalConfigurationTypes.creditReports}.jsonDefinition`),
      rolesSettingsKeys.hidden,
      userProfile.vendorContactRole
    );

    setIsCreditReportsHiddenForUserRole(isCreditReportsHiddenForUserRole);

    const isHealthCheckHiddenForUserRole = isItemHasRestrictionForRole(
      _.get(portalConfigurations, `${portalConfigurationTypes.healthCheck}.jsonDefinition`),
      rolesSettingsKeys.hidden,
      userProfile.vendorContactRole
    );
    setIsHealthCheckHiddenForUserRole(isHealthCheckHiddenForUserRole);
  }, [portalConfigurationData]);

  useEffect(() => {
    if (!voData?.vendorOpportunity) return;

    dispatch({ type: SET_VO, payload: voData.vendorOpportunity });
  }, [voData]);

  const handleLegacyCreditAppRequest = async () => {
    setOpenLegacyDetailsModal(true);

    return axios
      .post(
        `${DCR_API_BASE_SERVER_URL}/create-lender-pdf?transaction_id=${creditSubmissionData?.creditSubmission?.pgTransactionId}`,
        {
          dealerName: creditSubmissionData?.creditSubmission?.dealer,
          userProfile,
          dealerVendorProfile,
          download: false,
        },
        {
          responseType: 'json',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'text/html',
          },
        }
      )
      .then(response => {
        setAppSummary(response.data);
      })
      .catch(error => console.log(error));
  };

  const callbackSubmissionFinished = (dynamicsCreditSubmissionId: any) => {
    console.log(`Finished submission with ID ${dynamicsCreditSubmissionId}`);
    //Send mutation to update Lender Waterfall
    setHandleSubmitToLenderByProfileId(false);
  };

  const [pageContentViewType, setPageContentViewType] = useState<'full' | 'details'>('full');

  const invoiceDetailTableBody = creditSubmissionData?.creditSubmission
    ? invoiceDetailAPIKey.map(key => parseTableData(creditSubmissionData.creditSubmission, key))
    : [];
  invoiceDetailTableBody.forEach(item => (item[0] = <b>{item[0]}</b>));

  const customerData = creditAppData?.primaryContact
    ? creditAppData?.primaryContact
    : (creditAppData?.creditApplicationOwner?.find((o: any) => o!.pc) ?? creditAppData?.creditApplicationOwner?.[0]);

  const availableEmailOptions = getCcEmailPreSelectedValue(
    getCcEmailOptions(vo, creditAppData?.creditApplication, account.contacts),
    customerData?.email ?? '',
    vo,
    userProfile.email
  ).sort((a, b) => -b.group.localeCompare(a.group));

  const preSelectedValue = getCcEmailPreSelectedValue(
    availableEmailOptions,
    customerData?.email ?? '',
    vo,
    userProfile.email
  );

  const tabs: TabsOption<CreditSubmissionTabs>[] = [
    {
      label: 'General',
      value: CreditSubmissionTabs.General,
      isVisible: true,
      component: (
        <Box className={classes.generalContainer}>
          {enableEnhancedBusinessProcessFlows && creditSubmissionData?.creditSubmission?.creditSubmissionId && (
            <StagesWidget
              accountId={account.id}
              parentType={BpfLinkType.Cs}
              onSwitchToLegacyStages={() => {}}
              isDealClosed={!!creditSubmissionData.creditSubmission.closeInfo}
              parentId={creditSubmissionData.creditSubmission.creditSubmissionId}
              parentCreatedAt={creditSubmissionData.creditSubmission?.createdDateTime}
              closeReasonId={creditSubmissionData.creditSubmission.closeInfo?.reasonId ?? null}
              closedStatus={creditSubmissionData.creditSubmission.closeInfo?.closeDealStatus ?? null}
            />
          )}

          <Box className={classes.row}>
            <ApplicationSummary_V2
              goToCADView={() => {
                setPageContentViewType('details');
              }}
              cs={creditSubmissionData?.creditSubmission}
              vo={vo}
              lendersVendorProfile={vp}
              documents={documents}
              creditApplication={creditAppData?.creditApplication}
              isCreditReportsHiddenForUserRole={isCreditReportsHiddenForUserRole}
              isIndividualCreditApp={isIndividualCreditApp}
              refetchCreditApp={() => {
                getCreditAppData({
                  variables: {
                    VOId: _.get(creditSubmissionData, 'creditSubmission.voId', null),
                  },
                });
                refetchDocs();
              }}
              refetchDocs={refetchDocs}
              handleOpenCreditReportDocument={handleOpenCreditReportDocument}
              location={location}
            />
            <Box className={classes.row} flexDirection="column">
              <InvoiceEquipmentDetailsCard_V2
                invoiceDetailTableBody={invoiceDetailTableBody}
                cs={creditSubmissionData?.creditSubmission!}
              />
              <RenderWithFallback
                isLoading={!creditSubmissionData?.creditSubmission}
                fallBack={<Skeleton sx={{ height: '100px' }} />}
              >
                <DetailsCard
                  contacts={account.contacts}
                  initialContactsAssignments={creditSubmissionData?.creditSubmission?.assignmentTitles}
                  creditSubmissionId={creditSubmissionData?.creditSubmission.creditSubmissionId!}
                />
              </RenderWithFallback>
            </Box>
          </Box>

          {creditSubmissionData?.creditSubmission?.transactionSummary && (
            <Grid container direction="row" spacing={2}>
              <Grid item lg={6} xl={6} md={6} sm={12} xs={12}>
                <TransactionSummary cs={creditSubmissionData?.creditSubmission} />
              </Grid>
            </Grid>
          )}

          <>
            {showHealthCheck &&
              creditAppData?.creditApplication?.creditApplicationOwner?.length > 0 &&
              !isHealthCheckHiddenForUserRole && (
                <Tile title="Health Check" useCollapsing>
                  <HealthCheckCard
                    owners={creditAppData.creditApplication.creditApplicationOwner}
                    refetchCreditApp={() =>
                      getCreditAppData({
                        variables: {
                          VOId: _.get(creditSubmissionData, 'creditSubmission.voId', null),
                        },
                      })
                    }
                    vo={vo}
                    vp={dealerVendorProfile}
                    creditApp={creditAppData.creditApplication}
                    full={true}
                  />
                </Tile>
              )}

            <DecisionCard cs={creditSubmissionData?.creditSubmission as any} isDisabled={isLenderDeskingEnabled} />

            {creditSubmissionData?.creditSubmission.fastTrackResults &&
              creditSubmissionData.creditSubmission.fastTrackResults.inputs && (
                <ScoreCard
                  cs={creditSubmissionData.creditSubmission}
                  key={creditSubmissionData.creditSubmission.creditSubmissionId}
                />
              )}

            <MessageModal
              link={null}
              isOpen={openMessageModal}
              title={submissionMessage.title}
              handleCloseModal={handleCloseModal}
              message={submissionMessage.message}
            />
            <Grid container>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                {!hideScoreCard && creditAppData?.creditApplication ? (
                  <ScoreCardV2
                    vo={vo}
                    refetchVO={() => {}}
                    equipmentData={creditAppData?.creditApplication}
                    cs={creditSubmissionData?.creditSubmission}
                    refetchCreditSubmission={refetch}
                    refetchEquipment={() => {}}
                    equipmentLoading={false}
                    creditApplication={creditAppData?.creditApplication}
                    vp={dealerVendorProfile}
                    userProfile={userProfile}
                    account={account}
                    refetchCreditApp={() => {
                      getCreditAppData({
                        variables: {
                          VOId: _.get(creditSubmissionData, 'creditSubmission.voId', null),
                        },
                      });
                    }}
                    portalConfigurationDataLoading={
                      portalConfigurationDataLoading || CADMPortalConfigurationDataLoading
                    }
                    creditAppOwners={creditAppData?.creditApplication?.creditApplicationOwner}
                  />
                ) : null}
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              {account.dynamicsAccountId === '5e7f2efe-5c02-eb11-8125-065d4ad39109' && (
                <Grid item lg={12} xl={8} md={12} sm={12} xs={12}>
                  <ActivityList
                    vo={vo}
                    tileTitle=""
                    account={account}
                    userProfile={null}
                    creditSubId={creditSubmissionData?.creditSubmission?.creditSubId}
                  />
                </Grid>
              )}

              {account.dynamicsAccountId === '5e7f2efe-5c02-eb11-8125-065d4ad39109' && (
                <Grid item lg={12} xl={8} md={12} sm={12} xs={12}>
                  <FDRList
                    vo={vo}
                    cs={creditSubmissionData?.creditSubmission}
                    tileTitle=""
                    account={account}
                    userProfile={null}
                    dynamicsTransactionId={creditSubmissionData?.creditSubmission?.transactionId}
                  />
                </Grid>
              )}

              {/*  REMOVED BY DR-8663
              <RenderWithCondition condition={!!creditSubmissionData?.creditSubmission?.creditSubId}>
                <Grid item xs={12}>
                  <CreditSubmissionNotesCard
                    userName={generatePersonaFullName(userProfile)}
                    csId={creditSubmissionData?.creditSubmission?.creditSubmissionId!}
                    dynamicCSId={creditSubmissionData?.creditSubmission?.creditSubId!}
                  />
                </Grid>
              </RenderWithCondition> */}
            </Grid>
          </>
        </Box>
      ),
      urlAnchor: '#general',
    },
    {
      label: 'Activity Hub',
      isVisible: true,
      value: CreditSubmissionTabs.Activity,
      urlAnchor: '#activity',
      component: (
        <Grid item xs={12}>
          <DealActivityCard
            parentType={DealActivityLinkType.Cs}
            parentId={creditSubmissionData?.creditSubmission?.creditSubmissionId!}
          />
        </Grid>
      ),
    },
    {
      label: 'Tasks',
      value: CreditSubmissionTabs.Tasks,
      isVisible: true,
      component: (
        <SpecificTasks_V2
          vo={vo}
          cs={creditSubmissionData?.creditSubmission!}
          account={account}
          userProfile={userProfile}
          refetchDocs={refetchDocs}
        />
      ),
      urlAnchor: '#tasks',
    },
    {
      label: 'Documents',
      value: CreditSubmissionTabs.Documents,
      isVisible: true,
      component: allConfigurationsLoaded ? (
        <Documents_V2
          cs={creditSubmissionData?.creditSubmission}
          CADMData={CADMData}
          handleSetDocuments={setDocuments}
          triggerRefetchDocs={triggerRefetchDocs}
          portalConfigurations={portalConfigurations}
          isConfigurationLoaded={allConfigurationsLoaded}
        />
      ) : (
        <CircularProgress />
      ),
      urlAnchor: '#documents',
    },
    {
      label: 'LMS File',
      value: CreditSubmissionTabs.LMS,
      isVisible: !!allowLMS,
      component: (
        <>
          <Grid container spacing={1}>
            {!!allowLMS && (
              <Grid xs={12} item>
                <Paper sx={{ padding: 2 }}>
                  <Container maxWidth="xl">
                    <Grid container>
                      <Grid xs={2} item>
                        <FormControl fullWidth={false}>
                          <FormLabel id="demo-controlled-radio-buttons-group">LMS Available:</FormLabel>
                          <RadioGroup
                            aria-labelledby="demo-controlled-radio-buttons-group"
                            name="controlled-radio-buttons-group"
                            value={lmsCodeName}
                            radioGroup="lmsCodeName"
                            onChange={val => {
                              setLmsCodeName(val.target.value);
                            }}
                            row
                          >
                            {_.get(account, 'lms', []).map((lms: any) => {
                              return (
                                <FormControlLabel
                                  key={lms}
                                  value={lms}
                                  control={<Radio />}
                                  label={lms
                                    .replace(/_/g, ' ')
                                    .toLowerCase()
                                    .replace(/\b(\w)/g, (char: string) => char.toUpperCase())}
                                />
                              );
                            })}
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid xs={2} item>
                        <Button
                          fullWidth={true}
                          variant="contained"
                          /* disabled={_.get(creditSubmissionData, 'creditSubmission.lmsBookedData')} */
                          onClick={() => {
                            displayLMSModal(creditSubmissionData?.creditSubmission?.creditSubmissionId);
                          }}
                        >
                          Send <SendIcon />
                        </Button>
                      </Grid>
                    </Grid>
                  </Container>
                </Paper>
              </Grid>
            )}
            <Grid item xs={12}>
              {!!allowLMS && !!_.get(creditSubmissionData, 'creditSubmission.lmsBookedData') && (
                <LMSResults data={_.get(creditSubmissionData, 'creditSubmission.lmsBookedData', null)} />
              )}
            </Grid>
          </Grid>
        </>
      ),
      urlAnchor: '#lms',
    },
    {
      label: 'Syndications',
      value: CreditSubmissionTabs.Syndications,
      isVisible: allowSyndication,
      component: (
        <Grid container spacing={1}>
          {vo.vendorOpportunityId && allowSyndication && (
            <Grid item xs={12}>
              <LenderWaterfallResults
                creditSubmissions={creditSubmissionData?.creditSubmission}
                accountId={account.id}
                vendorOpportunityId={vo.vendorOpportunityId}
                handleSubmitToLenderByProfileId={setHandleSubmitToLenderByProfileId}
                lenderProfiles={vp.lenderProfiles?.filter((profile: any) => profile.id)}
              />
            </Grid>
          )}

          <Grid item xs={12}>
            <SyndicationsList_V2
              cs={creditSubmissionData?.creditSubmission}
              equipmentData={invoiceDetailTableBody}
              callbackSubmissionFinished={callbackSubmissionFinished}
              handleSubmitToLenderByProfileId={handleSubmitToLenderByProfileId}
              portalConfiguration={portalConfigurations}
            />
          </Grid>
        </Grid>
      ),
      urlAnchor: '#syndications',
    },
    {
      isVisible: !!vp,
      label: 'Proposals',
      urlAnchor: '#proposals',
      value: CreditSubmissionTabs.Proposals,
      component: (
        <ProposalList_V2
          account={account}
          pageType={PageTypes.CreditSubmission}
          cs={creditSubmissionData?.creditSubmission!}
          voId={creditSubmissionData?.creditSubmission?.voId}
          applicant={creditSubmissionData?.creditSubmission?.applicant}
        />
      ),
    },
    {
      label: 'Subsidy Calculator',
      value: CreditSubmissionTabs.SubsidyCalculator,
      isVisible: isSubsidyCalculatorEnabled,
      urlAnchor: '#subsidyCalculator',
      component: <SubsidyCalculatorPanel accountId={account.id} />,
    },
    {
      label: 'Decision',
      urlAnchor: '#desking',
      isVisible: isLenderDeskingEnabled,
      value: CreditSubmissionTabs.Desking,
      disabled: isCreditAppLoading || isLoadingCreditSubmissionData || isLoadingEquipmentData,
      component: (
        <CardContainer>
          <RenderWithFallback
            isLoading={isCreditAppLoading || isLoadingCreditSubmissionData || isLoadingEquipmentData}
            fallBack={
              <Stack height="100%" alignItems="center" justifyContent="center" gap="1rem">
                <Typography>Fetching data</Typography>
                <CircularProgress />
              </Stack>
            }
          >
            <LenderDeskingPanel
              accountId={account.id}
              voId={vo.vendorOpportunityId}
              invoice={collectInvoiceFromVO(vo)}
              preSelectedValue={preSelectedValue}
              currentUserEmail={userProfile.email}
              dealerEmail={voPrioritizedDealerEmail}
              equipment={equipmentData?.equipments ?? []}
              cs={creditSubmissionData?.creditSubmission}
              availableEmailOptions={availableEmailOptions}
              creditAppData={creditAppData?.creditApplication}
            />
          </RenderWithFallback>
        </CardContainer>
      ),
    },
  ];

  const render = {
    full: (
      <DocumentContext.Provider
        value={{
          lastDoc: lastDocument,
          documents: [],
          setLastDocument,
        }}
      >
        <PageContainer>
          <Stack gap="0.5rem" height="100%">
            <Paper className={classes.head} elevation={0}>
              <Stack>
                <Typography variant="h5">
                  Submission Details: {creditSubmissionData?.creditSubmission?.applicant}
                </Typography>

                <Breadcrumbs
                  currentValue="Detail"
                  config={[
                    { label: 'List View', value: 'list', onClick: () => push('/cs') },
                    { label: 'Detail', value: 'Detail', onClick: () => {} },
                  ]}
                />
              </Stack>

              {!!creditSubmissionData?.creditSubmission?.closeInfo && (
                <ClosedDealInfo {...creditSubmissionData.creditSubmission.closeInfo} />
              )}
            </Paper>

            <TabsContainer<CreditSubmissionTabs> tabs={tabs} isSyncWithAnchor TabsLabelWrapper={CardBackground} />
          </Stack>
        </PageContainer>
      </DocumentContext.Provider>
    ),
    details: (
      <CreditApplicationDetailsFullView
        backToCommonView={() => {
          setPageContentViewType('full');
        }}
        creditApplicationState={{
          isLegacyOCA,
          vo: CADMData?.vo,
          account: account,
          isEditingDisabled: true,
          applicant: creditSubmissionData?.creditSubmission?.applicant!,
          pageType: PageTypes.CreditSubmission,
          vendorProfile: CADMData?.vendorProfile,
          equipmentData: CADMData?.equipmentData,
          creditAppModalConfig: CADMData?.CADMPortalConfiguration?.jsonDefinition,
          handleLegacyCreditAppRequest,
        }}
      />
    ),
  };

  return (
    <PageContainer
      modals={modalsWithKeys}
      title="Submission details"
      error={creditSubmissionError}
      loading={isLoadingCreditSubmissionData}
    >
      {creditSubmissionData?.creditSubmission && render[pageContentViewType]}

      <Modal
        open={openLegacyDetailsModal}
        onClose={handleClose}
        aria-labelledby="Credit Application"
        aria-describedby="Summary"
      >
        <ApplicationSummaryModal {...appSummary} />
      </Modal>
      <Modal
        open={openLMSMappingModal}
        onClose={handleCloseLMSMappingModal}
        aria-labelledby="LMS Mapping Modal"
        aria-describedby="LMS Mapping Modal"
      >
        <LMSMappingModal
          handleClose={() => {
            setOpenLMSMappingModal(false);
          }}
          submissionMessage=""
          errors={['']}
          transactionSummary={''}
          submitCallback={(mapping: DynamicLenderMappingField[]) => {
            const lmsMappingMatrix = mapping.map((item: DynamicLenderMappingField) => ({
              value: item.mappedValue,
              property: item.lenderProperty,
            }));
            //when mapping is done close modal and run mutation
            bookDealLMS({
              variables: {
                input: {
                  creditSubmissionId: creditSubmissionData?.creditSubmission?.creditSubmissionId,
                  lmsCodeName,
                  lmsMappingMatrix,
                },
              },
            });
          }}
          key={'lms_modal'}
          lmsCodeName={lmsCodeName}
          lmsName={lmsCodeName
            .replace(/_/g, ' ')
            .toLowerCase()
            .replace(/\b(\w)/g, (char: string) => char.toUpperCase())}
          portalConfiguration={portalConfigurations}
          lender={lenderProfile}
          vo={vo}
        />
      </Modal>
    </PageContainer>
  );
};

const useStyles = makeStyles(theme => ({
  button: {
    margin: theme.spacing(1),
  },
  head: {
    padding: '0.5rem 1rem',
    gap: '0.5rem',
    display: 'grid',
    gridTemplateColumns: '1fr auto',
  },
  container: {
    gap: '0.3rem',
    display: 'flex',
    flexDirection: 'column',
  },
  generalContainer: {
    gap: '0.5rem',
    display: 'flex',
    flexDirection: 'column',
  },
  row: {
    display: 'flex',
    gap: '0.5rem',

    '& > *': {
      flexBasis: '50%',
    },
  },
}));
